module.exports = __webpack_public_path__ + "img/sextopiso.c8a5809d.jpg";